// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x2AJCL9NlMVyPj1lcZVg{flex-direction:column;flex:1;align-self:center;width:100%;max-width:760px;padding:0 16px;display:flex}.L2Zwrw1heGUZ3Rs5eQ3d{margin-top:28px;margin-left:3px}.Je4EG2PLYa05sfzSfpNz{height:inherit;flex-direction:column;flex-grow:1;display:flex}.u45DwIHtRYApodadRwFQ{align-items:center;gap:10px;padding:16px 3px 12px;display:flex}.u45DwIHtRYApodadRwFQ .DUyrwD_r_awiUzQqLnMn{flex:1}.u45DwIHtRYApodadRwFQ .DUyrwD_r_awiUzQqLnMn>input{height:24px;font-size:16px;font-style:normal;font-weight:400;line-height:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `x2AJCL9NlMVyPj1lcZVg`,
	"breadcrumbs": `L2Zwrw1heGUZ3Rs5eQ3d`,
	"wrap": `Je4EG2PLYa05sfzSfpNz`,
	"search": `u45DwIHtRYApodadRwFQ`,
	"field": `DUyrwD_r_awiUzQqLnMn`
};
export default ___CSS_LOADER_EXPORT___;
